var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import client from "@irati/utils/services/apollo";
import { TeamState } from "@irati/types";
import listFormat from "@irati/utils/services/graph/utils/listFormat";
// import teamErrorHandler from "./errors/teamErrorHandler"
import listTeamsQuery from "./queries/getTeams";
import getTeamQuery from "./queries/getTeam";
import addUserToTeamMutation from "./mutations/addUserToTeam";
import removeUserFromTeamMutation from "./mutations/removeUserFromTeam";
import createTeamMutation from "./mutations/createTeam";
import updateTeamMutation from "./mutations/updateTeam";
import deleteTeamMutation from "./mutations/deleteTeam";
var TeamService = /** @class */ (function () {
    function TeamService() {
    }
    TeamService.prototype.create = function (tenantId, team, options) {
        var variables = {
            tenantId: tenantId,
            team: teamInput(team)
        };
        return client
            .mutate(__assign(__assign({}, options), { mutation: createTeamMutation, variables: variables }))
            .then(function (_a) {
            var data = _a.data;
            return data.createTeam;
        });
    };
    TeamService.prototype.get = function (tenantId, teamId, options) {
        var variables = {
            tenantId: tenantId,
            teamId: teamId
        };
        return client.query(__assign(__assign({}, options), { query: getTeamQuery, variables: variables })).then(function (_a) {
            var data = _a.data;
            return data;
        });
    };
    TeamService.prototype.update = function (tenantId, team, ifMatch, options) {
        var variables = {
            tenantId: tenantId,
            team: teamInput(team),
            ifMatch: ifMatch
        };
        return client
            .mutate(__assign(__assign({}, options), { mutation: updateTeamMutation, variables: variables }))
            .then(function (_a) {
            var data = _a.data;
            return data.updateTeam;
        });
    };
    TeamService.prototype.delete = function (tenantId, teamId, ifMatch, options) {
        var variables = {
            tenantId: tenantId,
            teamId: teamId,
            ifMatch: ifMatch
        };
        return client
            .mutate(__assign(__assign({}, options), { mutation: deleteTeamMutation, variables: variables }))
            .then(function (_a) {
            var data = _a.data;
            return data.createTeam;
        });
    };
    TeamService.prototype.list = function (tenantId, _a, options) {
        var _b = _a === void 0 ? {} : _a, _c = _b.state, state = _c === void 0 ? TeamState.Ok : _c, _d = _b.userLimit, userLimit = _d === void 0 ? 0 : _d;
        var variables = {
            tenantId: tenantId,
            state: state,
            userLimit: userLimit
        };
        return client
            .query(__assign(__assign({}, options), { query: listTeamsQuery, variables: variables }))
            .then(function (_a) {
            var data = _a.data;
            return listFormat(data.teams);
        });
    };
    TeamService.prototype.watchList = function (tenantId, _a, options) {
        var _b = _a === void 0 ? {} : _a, _c = _b.state, state = _c === void 0 ? TeamState.Ok : _c, _d = _b.userLimit, userLimit = _d === void 0 ? 0 : _d;
        var promise = this.list(tenantId, { state: state, userLimit: userLimit }, options);
        var variables = {
            tenantId: tenantId,
            state: state,
            userLimit: userLimit
        };
        var watch = client.watchQuery(__assign(__assign({}, options), { query: listTeamsQuery, variables: variables }));
        return [watch, promise];
    };
    TeamService.prototype.addUserToTeam = function (teamId, userId, options) {
        var variables = {
            teamId: teamId,
            userId: userId
        };
        return client
            .mutate(__assign(__assign({}, options), { mutation: addUserToTeamMutation, variables: variables }))
            .then(function (_a) {
            var data = _a.data;
            return data.addUserToTeam;
        });
    };
    TeamService.prototype.removeUserFromTeam = function (teamId, userId, options) {
        var variables = {
            teamId: teamId,
            userId: userId
        };
        return client
            .mutate(__assign(__assign({}, options), { mutation: removeUserFromTeamMutation, variables: variables }))
            .then(function (_a) {
            var data = _a.data;
            return data.removeUserFromTeam;
        });
    };
    return TeamService;
}());
export default new TeamService();
function teamInput(team) {
    var data = {
        uuid: team.uuid,
        public_name: team.public_name,
        permissions: team.permissions,
        owners: team.owners,
        state: team.state
    };
    return data;
}
